/**
 * One unbuilt destination, drawn the way `pendingTreatment()` rules — the sidebar's rows and
 * Settings' sub-nav both render this, so the two navs cannot disagree on the Q5 treatment.
 */
import type { ReactNode } from "react";

import { Surface } from "@packagepage/ui";

import type { PendingTreatment } from "./pending.js";

export function PendingRow({
  label,
  treatment,
}: {
  readonly label: string;
  readonly treatment: PendingTreatment;
}): ReactNode {
  return (
    // The class is load-bearing. These rows used to be styled as `.pp-shell__nav span`,
    // which also matched the label span nested inside every link and painted the entire
    // sidebar ghost — see shell.css.
    <span className="pp-shell__pending" data-treatment={treatment} aria-disabled="true">
      <span>{label}</span>
      {treatment === "ghost" ? (
        <span className="pp-shell__soon">soon</span>
      ) : (
        // A pill-size inert Surface, not a restyled span: the ruling asks for the design
        // system's pill, and it already has one.
        <Surface tone="inert" size="pill">
          soon
        </Surface>
      )}
    </span>
  );
}
